import React from "react";

export const FormRequiredFieldIndicator: React.FC = () => <span className="text-danger">*</span>